import { Component, OnInit, ViewChild } from '@angular/core';
import { SupportRequestService } from './../support-request.service';
import { SupportRequest, TypeOptions, UrgencyOptions } from './support-request';
import { SystemGlobalsService } from './../system-globals.service';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import * as _ from 'underscore';
import { MdbSelectOption } from '../common/common-types';

@Component({
  selector: 'support-request',
  templateUrl: './support-request.component.html',
  styleUrls: ['./support-request.component.css']
})

export class SupportRequestComponent implements OnInit {

  @ViewChild('supportRequestModal') public supportRequestModal:ModalDirective;
  newRequest: SupportRequest;
  urgencyOptions: MdbSelectOption[] = _.map(Object.keys(UrgencyOptions), function(key) { return new MdbSelectOption(UrgencyOptions[key], key)});
  typeOptions: MdbSelectOption[] = _.map(Object.keys(TypeOptions), function(key) { return new MdbSelectOption(TypeOptions[key], key)});

  constructor(public globals: SystemGlobalsService, private supportRequestService: SupportRequestService, private toast: ToastService) { }

  ngOnInit() {
    this.newRequest = new SupportRequest(
      this.globals.constants._g_userName,
      this.globals.constants._g_networkName,
      this.globals.roles[this.globals.constants._g_userRole],
      this.globals.constants.refererUrl,
      window.location.href
    );
  }

  submitRequest(): void {
    if (this.newRequest._attachments.length > 0) this.newRequest.attachments = this.newRequest._attachments.split(',');
    //this.supportRequestService.newSupportRequest(this.newRequest).subscribe(_empty => this.supportRequestModal.hide());
    this.supportRequestService.newSupportRequest(this.newRequest).subscribe(
      () => {
        this.supportRequestModal.hide()
        this.toast.info('Support request submitted', 'Success', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
      },
      error => {
        this.toast.error(error, 'Support request not submitted', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
      }
    );
  }

  disableSubmit(): boolean {
    return !((this.newRequest.subject.length > 0) && (this.newRequest.urgency) && (this.newRequest.type) && (this.newRequest.details.length > 0));
  }
}
